import qs from 'query-string'

export const createCompareUrl = resources => qs.stringify(resources, { arrayFormat: 'bracket' })

export const stringifyObjectProperties = obj => qs.stringify({ placeholder: Object.entries(obj).map(([key, value]) => `${key}${value}`) }, { arrayFormat: 'bracket' })
